export function isPureLandingPage(pathname = window.location.pathname) {
  const path = String(pathname || '').trim() || '/';
  return [
    '/',
    '/pricing',
    '/about',
    '/contact'
  ].some((landingPath) => (
    landingPath === '/'
      ? path === landingPath
      : path === landingPath || path.startsWith(`${landingPath}/`)
  ));
}

export function isStandaloneDisplayMode() {
  try {
    return window.navigator.standalone === true
      || window.matchMedia('(display-mode: standalone)').matches;
  } catch (_) {
    return false;
  }
}

export function shouldAutoApplyServiceWorkerUpdate(pathname = window.location.pathname) {
  return isStandaloneDisplayMode() || !isPureLandingPage(pathname);
}

export function shouldReloadForServiceWorkerActivation(pathname = window.location.pathname) {
  return shouldAutoApplyServiceWorkerUpdate(pathname);
}
